export default {
  title: {
    en: 'Subscribe now: get 25% off first month',
  },
  hint: {
    en: 'Case included in your first order',
  },
}
